import Point from "../../../../../../src/entities/Point";
import BasePointManager from "../../../../../../src/managers/BasePointManager";
import { Coord, RedPointRadianInfo } from "../../../../../../src/types/Interface";
import { CIRCLE_RADIUS, INITIAL_INTERSEC_RADIUS, INITIAL_RADIANS } from "../../types/Config";
import { eventBus, EnumEventBus } from "../EventBus";
import { findIntersecCoord, generateChordPoints, getPointInfoArr } from "./helpers/pointHelpers";


export default class PointManager extends BasePointManager {
	private intersecLA = INITIAL_INTERSEC_RADIUS;
	private intersecLB = INITIAL_INTERSEC_RADIUS;
	private intersecPoint = new Point({ x: -100, y: -100 });
	private chordACoords: Coord[];
	private chordBCoords: Coord[];
	private pointCheckList: Boolean[] = [];
	private tags: string[] = [];

	constructor(cCoord: Coord) {
		super(cCoord, CIRCLE_RADIUS, INITIAL_RADIANS)
		this.setCoord();
		this.draw();

		[this.chordACoords,this.chordBCoords ] = this.getInitialChordCoords();

		const intersec = findIntersecCoord(this.cCoord, this.chordACoords, this.chordBCoords);
		this.intersecPoint.draw(intersec);

		this.tags = this.getRedPoints().map(p => p.tag);

		eventBus.on(EnumEventBus.setPointChecklist, l => this.pointCheckList = l);
		eventBus.on(EnumEventBus.rotateChords, (v: number) => this.handleRotateChords(v));
		eventBus.on(EnumEventBus.moveChordA, (v: number) => this.handleMoveChordA(v));
		eventBus.on(EnumEventBus.moveChordB, (v: number) => this.handleMoveChordB(v));
	}
	genChordInitialCoords = (rad:number, intersec:number) => generateChordPoints(this.cCoord, CIRCLE_RADIUS, rad, intersec);
	getInitialIntersecCoord = (initialCoords:Coord[][]) => findIntersecCoord(this.cCoord, initialCoords[0], initialCoords[1]);
	setIntersecPointInitial = (intersec:Coord) => Object.assign(this.intersecPoint, intersec)
	getInitialChordCoords = () => [
		this.genChordInitialCoords(INITIAL_RADIANS[0], INITIAL_INTERSEC_RADIUS),
		this.genChordInitialCoords(INITIAL_RADIANS[1], INITIAL_INTERSEC_RADIUS),
	];
	
	getChordsCoords = () => [this.chordACoords, this.chordBCoords];
	getIntersecCoord = () => ({ x: this.intersecPoint.x, y: this.intersecPoint.y });
	getIntersecPoint = () => this.intersecPoint;
	setIntersecPointVisible = (v: boolean) => this.intersecPoint.visible = v;

	setRadian(_pointInfoArr: RedPointRadianInfo[], isSlider?: boolean): void {
		const pointInfoArr = getPointInfoArr(_pointInfoArr, this.RedPointsArr, this.pointRadians);

		pointInfoArr.forEach(pointInfo => pointInfo.pTag == this.tags[0]
				?	this.chordACoords = generateChordPoints(this.cCoord, CIRCLE_RADIUS, pointInfo.radian, this.intersecLA)
				: this.chordBCoords = generateChordPoints(this.cCoord, CIRCLE_RADIUS, pointInfo.radian, this.intersecLB));

		if(this.intersecPoint.visible){
			const intersec = findIntersecCoord(this.cCoord, this.chordACoords, this.chordBCoords);
			this.intersecPoint.draw(intersec);
		}
		this._setRadian(pointInfoArr, isSlider);
	}

	private handleRotateChords(v: number) {
		const points = this.getRedPoints();
		const radians = this.getRefRadians();
		const generateOffsetRadian = (v: number) => (Math.PI / 300) * v;

		const pointInfoArr = this.pointCheckList
			.map((e, eI) => this.pointRefRadians[eI] + (e ? generateOffsetRadian(v) : 0))
			.map((r, rI) => ({ pTag: points[rI].tag, radian: r }))
			.filter((pointInfo, pII) => pointInfo.radian != radians[pII]);

		this.setRadian(pointInfoArr, true);
	}

	private handleMoveChordA(v: number) {
		this.intersecLA = Math.floor(v * .35 + INITIAL_INTERSEC_RADIUS);
		const pointInfoArr = this.getCurrRedPointInfo(0);
		this.setRadian(pointInfoArr, true);
	}

	private handleMoveChordB(v: number) {
		this.intersecLB = Math.floor(v * .35 + INITIAL_INTERSEC_RADIUS);
		const pointInfoArr = this.getCurrRedPointInfo(1);
		this.setRadian(pointInfoArr, true);
	}
	
	private getCurrRedPointInfo(index: number) {
		const point = this.RedPointsArr[index];
		const radian = this.pointRadians[index];
		return [{ pTag: point.tag, radian }]
	}
}